export default "__VITE_ASSET__CxtzeMxJ__"